import React, { useEffect, useState } from "react";
import { getNamesofAgreement, getTitlesOfAgreement } from "../apis/userApis";
import {
  Badge,
  Button,
  Pagination,
  Select,
  Table,
  Text,
  TextInput,
} from "@mantine/core";
import { useDispatch, useSelector } from "react-redux";
import { getSignedAgreementList } from "../apis/obligationApi";
import { converDateToISO, formatDate, getObStatusText } from "./utilities";

const SignedAgreementListModal = ({
  setSelectedAgreementData,
  setSelectedAgreementId,
  setShowModal,
}) => {
  const [configs, setConfigs] = useState({
    agreementsList: [],
    loading: true,
  });
  const [applyFilters, setApplyFilters] = useState(false);
  const [filters, setFilters] = useState({
    location: "",
    titleOfAgreement: "",
    businessUnit: "",
    typeOfAgreement: "",
    obligationStatus: "",
    jobOrder: {
      contains: "",
    },
    OR: [
      {
        secondParty: {
          path: "$.name",
          string_contains: "",
        },
      },
      {
        secondParty: {
          path: "$.indi_name",
          string_contains: "",
        },
      },
    ],
  });
  const [categoryOptions, setCategoryOptions] = useState([
    "NDA",
    "Service Agreement",
  ]);
  const [nameOptions, setNameOptions] = useState([
    "truecounsel NDA",
    "tc services",
  ]);

  useEffect(() => {
    const getTitles = async () => {
      const response = await getTitlesOfAgreement();
      if (response.success) {
        setNameOptions(response.titlesOfAgreement);
      }
    };
    const getNames = async () => {
      const response = await getNamesofAgreement();
      if (response.success) {
        setCategoryOptions(response.namesOfAgreement);
      }
    };
    getTitles();
    getNames();
  }, []);
  const [page, setPage] = useState(1);
  const [count, setCount] = useState(0);
  const [pageSize, setPageSize] = useState(10);

  // let filtersForData = Object.fromEntries(
  //   Object.entries(filters).filter(([key, value]) => value !== null)
  // );

  //     console.log("filtersForData: ", filtersForData);

  //     // Check if "OR" exists and has the expected structure before accessing its values
  // if (
  //   filtersForData.OR &&
  //   filtersForData.OR[0] &&
  //   filtersForData.OR[0].secondParty &&
  //   filtersForData.OR[0].secondParty.string_contains === ""
  // ) {
  //   filtersForData = Object.fromEntries(
  //     Object.entries(filtersForData).filter(([key]) => key !== "OR")
  //   );
  // }

  //     console.log("Updated filtersForData: ", filtersForData);
  //     console.log("filtersForData2: ", filtersForData);
  //     const response = await getLocalAgreements({
  //       page,
  //       filters: filtersForData,
  //     });
  //     if (response.success) {
  //       setConfigs({
  //         loading: false,
  //         agreements: response.agreements,
  //         count: response["count"],
  //       });
  //       console.log(configs);
  //     } else {
  //       setConfigs({
  //         loading: false,
  //         agreements: null,
  //         count: 0,
  //       });
  //     }
  //   };
  //   getAgreements();
  // }, [page, applyFilters]);

  useEffect(() => {
    const signedlist = async () => {
      let filtersForData = { ...filters };

      Object.keys(filtersForData).forEach((key) => {
        const value = filtersForData[key];

        if (value === null || value === undefined || value === "") {
          delete filtersForData[key];
        }
      });

      if (!filtersForData.jobOrder?.contains?.trim()) {
        delete filtersForData.jobOrder;
      }

      if (!filtersForData.OR?.[0]?.secondParty?.string_contains?.trim()) {
        delete filtersForData.OR;
      }

      if (filtersForData.businessUnit) {
        filtersForData.mapBusinessunit = filtersForData.businessUnit;
        delete filtersForData.businessUnit;
      }

      if (filtersForData.obligationStatus) {
        filtersForData.status = filtersForData.obligationStatus;
        delete filtersForData.obligationStatus;
      }

      console.log("filtersfordata: ", filtersForData);
      const SignedagreementList = await getSignedAgreementList({
        page: page,
        filters: filtersForData,
        pageSize,
      });
      console.log(SignedagreementList.agreementsList);
      setConfigs({
        agreementsList: SignedagreementList.agreementsList,
        loading: false,
      });
      setCount(SignedagreementList.count);
    };
    signedlist();
  }, [page, applyFilters, pageSize]);

  if (configs.loading) {
    return (
      <div className="flex justify-center p-8">
        <Text>Loading agreements...</Text>
      </div>
    );
  }

  return (
    <>
      {!configs.loading && (
        <div
          className="flex flex-col"
          style={{
            overflowX: "scroll",
            scrollbarWidth: "none",
            width: "100%",
          }}
        >
          <div className="grid grid-cols-6 gap-4 m-4">
            <Select
              searchable
              label="Contract Category"
              placeholder="Contract Category"
              value={filters.typeOfAgreement}
              data={categoryOptions}
              onChange={(val) =>
                setFilters({ ...filters, typeOfAgreement: val })
              }
            />
            <Select
              searchable
              placeholder="Agreement Title"
              label="Agreement Title"
              value={filters.titleOfAgreement}
              data={nameOptions}
              onChange={(val) =>
                setFilters({ ...filters, titleOfAgreement: val })
              }
            />
            {/* {buData !== null && (
          <Select
            label="business Unit"
            placeholder="select business Unit"
            data={buData}
            onChange={(val) => setFilters({ ...filters, businessUnit: val })}
            value={filters.businessUnit}
          />
        )} */}
            <TextInput
              label="Second Party"
              type="text"
              placeholder="Type to search..."
              value={filters.OR?.[0]?.secondParty?.string_contains || ""}
              onChange={(e) => {
                // const value = e.target.value;

                setFilters((prevFilters) => ({
                  ...prevFilters, // Preserve the existing filters
                  OR: [
                    {
                      secondParty: {
                        path: "$.name",
                        string_contains: e.target.value,
                      },
                    },
                    {
                      secondParty: {
                        path: "$.indi_name",
                        string_contains: e.target.value,
                      },
                    },
                  ],
                }));
              }}
            />
            <TextInput
              label="Job Order"
              placeholder="Enter job order "
              value={filters.jobOrder?.contains || ""}
              onChange={(e) =>
                setFilters({
                  ...filters,
                  jobOrder: { ...filters.jobOrder, contains: e.target.value },
                })
              }
            />
            <Select
              className="mx-2"
              label="Obligation Status"
              placeholder="Select Obligation Status"
              value={filters.obligationStatus}
              data={[
                { label: "NA", value: "NA" },
                { label: "created", value: "created" },
                { label: "not required", value: "not required" },
              ]}
              onChange={(value) => {
                setFilters((prevState) => ({
                  ...prevState,
                  obligationStatus: value,
                }));
              }}
              style={{ minWidth: "228px" }}
            />

            {/* <Select
          placeholder="location"
          label="location"
          value={filters.location}
          data={INDIA_STATES_UNIONS}
          onChange={(val) => setFilters({ ...filters, location: val })}
        /> */}
          </div>
          <div className="m-4">
            <Button
              onClick={() => setApplyFilters(!applyFilters)}
              className="mr-4"
              variant="outline"
            >
              Search
            </Button>
            <Button
              onClick={() => {
                setFilters({
                  location: null,
                  titleOfAgreement: null,
                  businessUnit: null,
                  typeOfAgreement: null,
                  OR: [
                    { secondParty: { path: "$.name", string_contains: "" } },
                    {
                      secondParty: {
                        path: "$.indi_name",
                        string_contains: "",
                      },
                    },
                  ],
                });
                setApplyFilters(!applyFilters);
              }}
              color="#1b6f8d"
            >
              Clear
            </Button>
          </div>
          <Table striped>
            <thead>
              <tr>
                <th>select</th>
                <th>reference no.</th>
                <th>type</th>
                <th>job order</th>
                <th>status</th>
                <th>second party</th>
                <th>end date</th>
                <th>obligation status</th>
              </tr>
            </thead>
            <tbody id="tablebody">
              {configs.agreementsList.length > 0 ? (
                configs.agreementsList.map((agreement) => (
                  <tr
                    key={agreement.id}
                    className="cursor-pointer hover:bg-slate-50 transition-colors"
                    onClick={() => {
                      setSelectedAgreementId(null);
                      setSelectedAgreementData(null);

                      setTimeout(() => {
                        setSelectedAgreementId(agreement.id);
                        setSelectedAgreementData(agreement);
                        setShowModal(false);
                      }, 0);
                    }}
                  >
                    <td>
                      <td>
                        <Button size="xs" variant="light" color="blue">
                          Select
                        </Button>
                      </td>
                    </td>
                    <td>{agreement.id}</td>
                    <td>{agreement.typeOfAgreement}</td>
                    <td>{agreement.jobOrder}</td>
                    <td>{agreement.status}</td>
                    <td>
                      <Text>{agreement.secondParty?.brandName || ""}</Text>
                      <Text>({agreement.secondParty?.name || ""})</Text>
                    </td>
                    <td>{formatDate(agreement.dueDateOfContract)}</td>
                    <td>
                      <Badge
                        color={
                          getObStatusText(agreement.obligationStatus).color
                        }
                      >
                        {getObStatusText(agreement.obligationStatus).text}
                      </Badge>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td
                    colSpan={8}
                    style={{ textAlign: "center", padding: "30px" }}
                  >
                    <div className="text-center py-10">
                      <div className="flex flex-col items-center py-12">
                        <Text size="lg" fw={600}>
                          No agreements found
                        </Text>

                        <Text c="dimmed" mt={4}>
                          Try changing the search filters and search again.
                        </Text>
                      </div>
                      <Text color="dimmed">
                        Try changing the search filters and search again.
                      </Text>
                    </div>
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        </div>
      )}
      {!configs.loading && count > 0 && (
        <div className="flex flex-row justify-center my-4 gap-6">
          <Pagination
            page={page}
            onChange={(page) => {
              setPage(page);
            }}
            total={Math.ceil(count / pageSize)}
          />
          <Select
            style={{ width: "100px" }}
            value={String(pageSize)}
            onChange={(val) => setPageSize(Number(val))}
            data={[
              { label: "10", value: "10" },
              { label: "20", value: "20" },
              { label: "50", value: "50" },
            ]}
          />
        </div>
      )}
    </>
  );
};

export default SignedAgreementListModal;
